@if (show_banner()) {

  <div class="cookie-banner-container" role="alert">

    <div class="cookie-content">
      <div class="cookie-header">
        <p class="cookie-text">
          We use cookies to analyze traffic and improve your experience.
          <a class="cookie-link" href="/legal-information#cookie-policy">Read strict policy</a>
        </p>
      </div>

      @if (!show_preferences()) {

        <div class="cookie-actions">
          <button type="button" class="btn btn-secondary" (click)="onDeny()">Deny</button>
          <button type="button" class="btn btn-secondary" (click)="onSelectPreferences()">Preferences</button>
          <button type="button" class="btn btn-primary" (click)="onAccept()">Accept</button>
        </div>

      } @else {

        <div class="cookie-preferences">
          
          <div class="preference-item">
            <label class="preference-control">
              <span class="preference-label">Analytics</span>
              <input type="checkbox" class="preference-checkbox" [checked]="analytics_consent()" (change)="onToggleAnalytics()">
            </label>
            <p class="preference-description">Helps us understand how you use the app to improve the game flow.</p>
          </div>
          
          <div class="preference-item">
            <label class="preference-control">
              <span class="preference-label">Marketing</span>
              <input type="checkbox" class="preference-checkbox" [checked]="marketing_consent()" (change)="onToggleMarketing()">
            </label>
            <p class="preference-description">Used to measure the effectiveness of our social media campaigns.</p>
          </div>
        
          <div class="cookie-actions">
            <button type="button" class="btn btn-secondary" (click)="onHidePreferences()">Back</button>
            <button type="button" class="btn btn-primary" (click)="onSavePreferences()">Save preferences</button>
          </div>

        </div>

      }
    </div>

  </div>

}
